import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import is from "is_js";
import FalconRoutes from "routes";
import { CloseButton } from "components/common/Toast";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.min.css";
import { useAppContext } from "Main";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store } from "./Redux/store";
import { persistStore } from "redux-persist";



import { Quill } from "react-quill";
import ImageResize from 'quill-image-resize-module-react';

import { ImageActions } from '@xeger/quill-image-actions';
import { ImageFormats } from '@xeger/quill-image-formats';

// import QuillBetterTable from 'quill-better-table';



const App = () => {
  
  Quill.register('modules/imageResize', ImageResize);
  Quill.register('modules/imageActions', ImageActions);
  Quill.register('modules/imageFormats', ImageFormats);
  
  // Quill.register('modules/better-table', QuillBetterTable);

  // const quillTable = require('quill-table');
  // Quill.register(quillTable.TableCell);
  // Quill.register(quillTable.TableRow);
  // Quill.register(quillTable.Table);
  // Quill.register(quillTable.Contain);
  // Quill.register('modules/table', quillTable.TableModule, true);

  const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  const {
    config: { navbarPosition },
  } = useAppContext();

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add("windows");
    }
    if (is.chrome()) {
      HTMLClassList.add("chrome");
    }
    if (is.firefox()) {
      HTMLClassList.add("firefox");
    }
    if (is.safari()) {
      HTMLClassList.add("safari");
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === "double-top") {
      HTMLClassList.add("double-top-nav-layout");
    }
    return () => HTMLClassList.remove("double-top-nav-layout");
  }, [navbarPosition]);

  let persistor = persistStore(store);

  return (
    <Provider store={store}>
      <PersistGate loading={<div>loading</div>} persistor={persistor}>

        <Router>

          <FalconRoutes />

          {/* <SettingsToggle />
          <SettingsPanel /> */}

          <ToastContainer
            closeButton={CloseButton}
            icon={false}
            position={toast.POSITION.BOTTOM_LEFT}
          />
        </Router>

      </PersistGate>
    </Provider>
  );
};

export default App;
